import { render, staticRenderFns } from "./SectionItem.vue?vue&type=template&id=603a22b1&scoped=true&"
import script from "./SectionItem.vue?vue&type=script&lang=ts&"
export * from "./SectionItem.vue?vue&type=script&lang=ts&"
import style0 from "./SectionItem.vue?vue&type=style&index=0&id=603a22b1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "603a22b1",
  null
  
)

export default component.exports